// import React, { useState } from 'react';
// import { Menu, X } from 'lucide-react';

// const CBSEDocuments = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [selectedDocument, setSelectedDocument] = useState('/CBSE/AFFILIATION_LETTER_2026.pdf');

//   const documents = [
//     { title: 'Affiliation', path: '/CBSE/AFFILIATION_LETTER_2026.pdf' },
//      { title: 'NOC', path: '/CBSE/NOC_2026.pdf' },
//       { title: 'Academic Calender', path: '/CBSE/ACADEMIC_CALENDER_2026.pdf' },
//     // { title: 'Fitness Certificate', path: '/CBSE/fitness certificate building.pdf' },
//     { title: 'Building Safety', path: '/CBSE/BUILDING_SAFETY_CERTIFICATE_2026.pdf' },
//     { title: 'Drinking Water', path: 'CBSE/WATER_HEALTH_SANITATION_CERTIFICATE_2026.pdf' },
//     { title: 'Income & Expense', path: '/CBSE/INCOME_EXPENDITURE_2026.pdf' },
//      { title: 'Balance Sheet', path: '/CBSE/BALANCE_SHEET_2026.pdf' },
//     { title: 'Land Certificate', path: '/CBSE/LAND_CERTIFICATE_2026.pdf' },
//     { title: 'Non Proof', path: '/CBSE/NON PROPRETARY.pdf' },
//     { title: 'Trust Members', path: '/CBSE/SMC.pdf' },
//     { title: 'Self Certificate', path: '/CBSE/self certification.pdf' },
//     { title: 'Sanitary Certificate', path: '/CBSE/SANITATION.pdf' },
//     { title: 'Staff Statement', path: '/CBSE/staff statement.pdf' },
//      { title: 'Fire & Safty', path: '/CBSE/FIRE& SAFTY.pdf' },
//       { title: 'Fees', path: '/CBSE/FEES.pdf' },
//        { title: 'Board Result', path: '/CBSE/BOARD RESULT.pdf' }
      
       
//   ];

//   const handleDocumentSelect = (path) => {
//     setSelectedDocument(path);
//     setIsMobileMenuOpen(false);
//   };

//   return (
//     <div className="flex flex-col md:flex-row h-[calc(100vh-150px)]">
//       {/* Mobile Menu Toggle */}
//       <button
//         className="md:hidden fixed top-4 left-4 z-50 p-2 bg-gray-100 rounded-md shadow"
//         onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//       >
//         {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
//       </button>

//       {/* Side Menu */}
//       <div
//         className={`
//           ${isMobileMenuOpen ? 'block' : 'hidden'}
//           md:block
//           fixed md:static
//           top-0 left-0 w-full md:w-64
//           h-full
//           bg-white
//           md:border-r
//           shadow-lg
//           md:shadow-sm
//           z-40
//           overflow-y-auto
//           pt-16 md:pt-0
//         `}
//       >
//         <ul className="p-4 space-y-2">
//           {documents.map((doc, index) => (
//             <li key={index}>
//               <button
//                 onClick={() => handleDocumentSelect(doc.path)}
//                 className="w-full text-left px-4 py-2 text-sm text-gray-700 rounded-md hover:bg-gray-100 transition-colors"
//               >
//                 {doc.title}
//               </button>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Content Area */}
//       <div className="flex-1 h-full">
//         <iframe
//           src={selectedDocument}
//           title="CBSE Document Viewer"
//           className="w-full h-full border-none"
//         />
//       </div>

//       {/* Overlay for mobile menu */}
//       {isMobileMenuOpen && (
//         <div
//           className="fixed inset-0 bg-black/50 z-30 md:hidden"
//           onClick={() => setIsMobileMenuOpen(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default CBSEDocuments;
import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

const CBSEDocuments = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const { document } = useParams();

  const documents = [
    {
      title: 'Affiliation',
      urlName: 'AFFILIATION_LETTER_2026.pdf',
      path: '/CBSE/AFFILIATION_LETTER_2026.pdf'
    },
    {
      title: 'NOC',
      urlName: 'NOC_2026.pdf',
      path: '/CBSE/NOC_2026.pdf'
    },
    {
      title: 'Academic Calender',
      urlName: 'ACADEMIC_CALENDER_2026.pdf',
      path: '/CBSE/ACADEMIC_CALENDER_2026.pdf'
    },
    {
      title: 'Building Safety',
      urlName: 'building-safety.pdf',
      path: '/CBSE/BUILDING_SAFETY_CERTIFICATE_2026.pdf'
    },
    {
      title: 'Drinking Water',
      urlName: 'BUILDING_SAFETY_CERTIFICATE_2026.pdf',
      path: '/CBSE/WATER_HEALTH_SANITATION_CERTIFICATE_2026.pdf'
    },
    {
      title: 'Income & Expense',
      urlName: 'INCOME_EXPENDITURE_2026.pdf',
      path: '/CBSE/INCOME_EXPENDITURE_2026.pdf'
    },
    {
      title: 'Balance Sheet',
      urlName: 'BALANCE_SHEET_2026.pdf',
      path: '/CBSE/BALANCE_SHEET_2026.pdf'
    },
    {
      title: 'Land Certificate',
      urlName: 'LAND_CERTIFICATE_2026.pdf',
      path: '/CBSE/LAND_CERTIFICATE_2026.pdf'
    },
    {
      title: 'Non - Propretary',
      urlName:'NON_PROPRETARY_2026.pdf',
      path:'/CBSE/NON_PROPRIETARY_2026.pdf'
    },
    {
      title: 'Trust Members',
      urlName: 'SMC_2026.pdf',
      path: '/CBSE/SMC_2026.pdf'
    },
    
    {
      title: 'Sanitary Certificate',
      urlName: 'sanitary-certificate.pdf',
      path: '/CBSE/SANITATION.pdf'
    },
    {
      title: 'Recognition Certificate',
      urlName: 'RECOGNITION_CERTIFICATE.pdf',
      path: '/CBSE/RECOGNITION_CERTIFICATE.pdf'
    },
    {
      title: 'Fire & Safety',
      urlName: 'FIRE_SAFETY_CERTIFICATE_2026.pdf',
      path: '/CBSE/FIRE_SAFETY_CERTIFICATE_2026.pdf'
    },
    {
      title: 'Fees Structure',
      urlName: 'FEES_STRUCTURE_2026.pdf',
      path: '/CBSE/FEES_STRUCTURE_2026.pdf'
    },
    {
      title: 'Board Result',
      urlName: 'BOARD_RESULTS_2026.pdf',
      path: '/CBSE/BOARD_RESULTS_2026.pdf'
    },
     {
      title: 'PTA ',
      urlName: 'PTA_2026.pdf',
      path: '/CBSE/PTA_2026.pdf'
    },
     {
      title: 'Society Renewal',
      urlName: 'SOCIETY RENEWAL_CERTIFICATE_2026.pdf',
      path: '/CBSE/SOCIETY RENEWAL_CERTIFICATE_2026.pdf'
    },
    {
      title: 'All Certificate',
      urlName: '/CBSE/ALL_2026.pdf',
      path: '/CBSE/ALL_2026.pdf'
    },
  ];

  // Find selected document from URL
  const selectedDoc =
    documents.find(doc => doc.urlName === document) || documents[0];

  const handleDocumentSelect = (doc) => {
    navigate(`/cbse/${doc.urlName}`);
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="flex flex-col md:flex-row h-[calc(100vh-150px)]">

      {/* Mobile Menu Toggle */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 p-2 bg-gray-100 rounded-md shadow"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {isMobileMenuOpen ? (
          <X className="h-6 w-6" />
        ) : (
          <Menu className="h-6 w-6" />
        )}
      </button>

      {/* Side Menu */}
      <div
        className={`
          ${isMobileMenuOpen ? 'block' : 'hidden'}
          md:block
          fixed md:static
          top-0 left-0 w-full md:w-64
          h-full
          bg-white
          md:border-r
          shadow-lg
          md:shadow-sm
          z-40
          overflow-y-auto
          pt-16 md:pt-0
        `}
      >
        <ul className="p-4 space-y-2">
          {documents.map((doc, index) => (
            <li key={index}>
              <button
                onClick={() => handleDocumentSelect(doc)}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 rounded-md hover:bg-gray-100 transition-colors"
              >
                {doc.title}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Content Area */}
      <div className="flex-1 h-full">
        <iframe
          src={selectedDoc.path}
          title="CBSE Document Viewer"
          className="w-full h-full border-none"
        />
      </div>

      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 md:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </div>
  );
};

export default CBSEDocuments;
